import React, { useMemo } from 'react'

import { Text } from '@chakra-ui/react'

import { MARK_STYLES } from '../../../constants/highlightConfig'
import { sanitizeHighlight } from '../../../utils'
import { NoValue } from '../../ui'

/**
 * Component to safely render HTML-highlighted text with stemming support
 * Displays text with <mark> tags for search highlights from PostgreSQL SearchHeadline
 * Uses DOMPurify to prevent XSS attacks while preserving highlight marks
 */
const HighlightedText = ({ html, maxLength = 300, ...textProps }) => {
  if (!html) return <NoValue />

  const sanitized = useMemo(() => {
    const cleaned = sanitizeHighlight(html)

    if (cleaned.length > maxLength) {
      const truncated = cleaned.slice(0, maxLength)
      const openMarks = (truncated.match(/<mark>/g) || []).length
      const closeMarks = (truncated.match(/<\/mark>/g) || []).length
      if (openMarks > closeMarks) {
        return truncated + '</mark>...'
      }
      return truncated + '...'
    }
    return cleaned
  }, [html, maxLength])

  return (
    <Text
      dangerouslySetInnerHTML={{ __html: sanitized }}
      sx={MARK_STYLES}
      {...textProps}
    />
  )
}

export default HighlightedText
